import {
  deleteUserAct
  // getToken, deleteToken
  , setToken
} from "../../utils/token";

// Action Types
export const actionTypes = {
  AUTH_CHECK: "AUTH_CHECK",
  AUTH_LOGIN: "AUTH_LOGIN",
  AUTH_LOGOUT: "AUTH_LOGOUT",
  AUTH_REFRESH_TOKEN: "AUTH_REFRESH_TOKEN",
  AUTH_RESET_PASSWORD: "AUTH_RESET_PASSWORD",
  AUTH_USER: "AUTH_USER",

  LOGOUT_REQUEST: "LOGOUT_REQUEST",

  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILED: "LOGIN_FAILED",

  CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILED: "CHANGE_PASSWORD_FAILED",

  FORGOT_PASSWORD_REQUEST: "FORGOT_PASSWORD_REQUEST",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILED: "FORGOT_PASSWORD_FAILED",

  RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_FAILED: "RESET_PASSWORD_FAILED",

  CUSTOMER_LOGIN_REQUEST: "CUSTOMER_LOGIN_REQUEST",
  CUSTOMER_LOGIN_REQUEST_SUCCESS: "CUSTOMER_LOGIN_REQUEST_SUCCESS",
  CUSTOMER_LOGIN_REQUEST_FAILED: "CUSTOMER_LOGIN_REQUEST_FAILED"
};

// Action creators
export const actionCreators = {
  logout: payload => ({ type: actionTypes.LOGOUT_REQUEST, payload }),
  login: payload => ({ type: actionTypes.LOGIN_REQUEST, payload }),
  changePassword: payload => ({
    type: actionTypes.CHANGE_PASSWORD_REQUEST,
    payload
  }),
  customerLogin: payload => ({
    type: actionTypes.CUSTOMER_LOGIN_REQUEST,
    payload
  }),
  forgotPassword: payload => ({
    type: actionTypes.FORGOT_PASSWORD_REQUEST,
    payload
  }),
  resetPassword: payload => ({
    type: actionTypes.RESET_PASSWORD_REQUEST,
    payload
  })
};

// Reducer
const initialState = {
  isAuthenticated: false,
  isLoading: false,
  accessToken: null,
  errors: null,
  request_error: [],
  changePasswordData: [],
  isChangingPassword: false,
  forgotPasswordData: [],
  isForgotPassword: false,
  isCustomer: false,
  customerReserveNo: null,
  resetPasswordData: [],
  isResettingPassword: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CUSTOMER_LOGIN_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
        errors: null
      });

    case actionTypes.CUSTOMER_LOGIN_REQUEST_SUCCESS:
      setToken(action.auth.access_token);
      deleteUserAct();

      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        isAuthenticated: true,
        isCustomer: true,
        accessToken: action.auth.access_token,
        customerReserveNo: action.auth.reservation_no
      });

    case actionTypes.CUSTOMER_LOGIN_REQUEST_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        errors: action.errors,
        isAuthenticated: false,
        isCustomer: false,
        accessToken: null,
        customerReserveNo: null
      });

    case actionTypes.LOGOUT_REQUEST:
      return Object.assign({}, state, {
        errors: null
      });

    case actionTypes.LOGIN_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
        errors: null
      });

    case actionTypes.LOGIN_SUCCESS:
      setToken(action.auth.access_token);
      deleteUserAct();

      return Object.assign({}, state, {
        isLoading: false,
        errors: null,
        isAuthenticated: true,
        accessToken: action.auth.access_token
      });

    case actionTypes.LOGIN_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        errors: action.errors,
        isAuthenticated: false,
        accessToken: null
      });

    case actionTypes.CHANGE_PASSWORD_REQUEST:
      return Object.assign({}, state, {
        isChangingPassword: true,
        changePasswordData: [],
        errors: null
      });

    case actionTypes.CHANGE_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        isChangingPassword: false,
        changePasswordData: action.changePassword,
        errors: null
      });
    case actionTypes.CHANGE_PASSWORD_FAILED:
      return Object.assign({}, state, {
        isChangingPassword: false,
        errors: action.errors
      });

    case actionTypes.FORGOT_PASSWORD_REQUEST:
      return Object.assign({}, state, {
        isForgotPassword: true,
        forgotPasswordData: [],
        errors: null
      });

    case actionTypes.FORGOT_PASSWORD_SUCCESS:
      console.log("FORGOT_PASSWORD_SUCCESS", action);
      return Object.assign({}, state, {
        isForgotPassword: false,
        forgotPasswordData: action,
        errors: null
      });

    case actionTypes.FORGOT_PASSWORD_FAILED:
      return Object.assign({}, state, {
        isForgotPassword: false,
        errors: action.error
      });

    case actionTypes.RESET_PASSWORD_REQUEST:
      return Object.assign({}, state, {
        isResettingPassword: true,
        resetPasswordData: [],
        errors: null
      });

    case actionTypes.RESET_PASSWORD_SUCCESS:
      // console.log("RESET_PASSWORD_SUCCESS", action);
      return Object.assign({}, state, {
        isResettingPassword: false,
        resetPasswordData: action,
        errors: null
      });

    case actionTypes.RESET_PASSWORD_FAILED:
      // console.log("RESET_PASSWORD_FAILED", action);
      return Object.assign({}, state, {
        isResettingPassword: false,
        errors: action.error
      });

    default:
      return state;
  }
};
